import api from '../utils/api';
import { CommissionPaymentInput, CommissionSummary } from '../types/commissionPayment.types';

// Get commission payments for a contract
export const getCommissionPayments = async (contractId: string): Promise<CommissionSummary> => {
  const response = await api.get(`/commission/${contractId}/payments`);
  return response.data;
};

// Add a commission payment
export const addCommissionPayment = async (
  contractId: string,
  payment: CommissionPaymentInput
): Promise<any> => {
  const response = await api.post(`/commission/${contractId}/payments`, payment);
  return response.data;
};

// Update a commission payment
export const updateCommissionPayment = async (
  contractId: string,
  paymentId: string,
  payment: CommissionPaymentInput
): Promise<any> => {
  const response = await api.put(`/commission/${contractId}/payments/${paymentId}`, payment);
  return response.data;
};

// Delete a commission payment
export const deleteCommissionPayment = async (
  contractId: string,
  paymentId: string
): Promise<any> => {
  const response = await api.delete(`/commission/${contractId}/payments/${paymentId}`);
  return response.data;
};
